import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Button, Dropdown, DropdownButton, Tooltip, OverlayTrigger, Form } from 'react-bootstrap';
import { getDashboardFlags, filterDashboards } from '../../util/dashboardUtils';

import windowSize from 'react-window-size';

import FormattedMessage from '../FormattedMessage';
import Header from '../Header/Header';
import Confirm from '../Confirm/Confirm';
import ImageSize from '../ImageSize/ImageSize';
import Checkbox from '../Checkbox/Checkbox';

import { clearData as clearDataCFD } from '../../modules/CFD/CFDActions';

import {
  selectDashboard,
  saveSelected,
  updateModel,
  listAll,
  loadAkb,
  remove,
  downloadReport,
  applyView
} from './DashboardSelectorActions';
import { exportCsv } from '../../modules/Exporting/ExportingActions';

import DashboardViews from '../DashboardView/DashboardViews';
import SaveDashboardView from '../DashboardView/SaveDashboardView';
import ProgressDashboard from '../ProgressDashboard/ProgressDashboard';

import { hasDashboardAccess, hasCreateDashboards } from '../../util/roles';
import { OBJECT_ID_REGEX, isDashboardWithoutId } from '../../util/pageRules';
import { translate } from '../../util/translate';

import deleteIcon from '../../assets/img/delete.svg';

import createDashboardIcon from '../../assets/img/createDashboard-icon.svg';
import settingsIcon from '../../assets/img/settings-icon.svg';
import wallboardIcon from '../../assets/img/wallboard-icon.svg';
import saveIcon from '../../assets/images/save.svg';
import applyIcon from '../../assets/images/check-square-fill.svg';
import defaultBoardImg from '../../assets/images/board-default-icon.svg';
import personalBoardImg from '../../assets/images/board-person-icon.svg';
import editIcon from '../../assets/images/edit-blue.svg';
import cloudDownload from '../../assets/images/cloud-download-icon.svg';
import filterIcon from '../../assets/img/filter-icon.svg';
import dashboardIcon from '../../assets/img/dashboard.svg';
import akbIcon from '../../assets/images/universal-board-logo.svg';
import akbGrayIcon from '../../assets/images/ub-app-icon.svg';

const PLUGIN_PATH = process.env.RUN_ENV === 'production' ?
  '/plugins/servlet/ac/app.releasemanagement.agile-board' :
  '/plugins/servlet/ac/app.releasemanagement.agile-board.staging';

import '../Header/Header.scss';

function idDecode(str) {
  if (!str) {
    return {};
  }
  const jsonStr = Buffer.from(str, 'base64').toString();
  return JSON.parse(jsonStr);
}


export class DashboardSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: false,
      akbIsSet: false,
      akbFlag: false,
      akbShowChecked: true,
      q: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleUpdateClick = this.handleUpdateClick.bind(this);
    this.handleShowFilter = this.handleShowFilter.bind(this);
    this.handleAkbShowChecked = this.handleAkbShowChecked.bind(this);
  }

  componentDidMount() {
    if (!this.props.dashboards.length) {     
      this.props.listAll();
    } else if (
      !this.props.selected ||
      !this.props.selected._id ||
      _.findIndex(this.props.dashboards, { _id: this.props.selected._id }) === -1
    ) {
      this.selectDashboard();
    }        
    this.loadAkb();
  }

  redirectToCreate() {
    this.props.router.replace(`/create${this.props.router.location.search}`);
  }

  componentDidUpdate(prevProps) {
    if (this.props.noDashboards === true) {
      this.redirectToCreate();
    }

    if (this.props.dashboards.length && !_.isEqual(prevProps.dashboards, this.props.dashboards)) {
      if (this.props.location.query.dashboardId) {
        const found = _.find(this.props.dashboards, {
          _id: this.props.location.query.dashboardId
        });
        !found && this.redirectToCreate();
      } else if (this.props.location.query.aid) {
        this.redirectToCreate();
      }
      this.selectDashboard();
    } else if (!this.props.dashboards.length) {
      this.props.select(undefined);
    }  

    if (!_.isEqual(prevProps.plugin, this.props.plugin)) {
      this.loadAkb();
    }
  }

  loadAkb() {
   if (
      this.props.plugin && 
      this.props.plugin.app === 'jira'
    ) {
      const showAkbConfirm = localStorage.getItem('show_akb_confirm');
      const akbIsSet = !!showAkbConfirm;
      const akbShowChecked = showAkbConfirm === 'true' || !akbIsSet;
      this.props.loadAkb();
      this.setState({ akbIsSet, akbShowChecked });
    }
  }

  open(url) {
    localStorage.setItem('show_akb_confirm', (!this.state.akbFlag).toString());
    this.setState({ akbIsSet: true, akbShowChecked: !this.state.akbFlag });

    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('target', '_blank');
  
    link.setAttribute('style', 'visibility:hidden');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  selectDashboard() {
    if (!!this.props.wallmode) {
      return false;
    }

    let found;
    let selectedDashboard = this.props.dashboards[this.props.dashboards.length - 1];
    const selected = this.props.selected;

    if (selected && selected._id) {
      found = _.find(this.props.dashboards, b => b._id == selected._id);
      if (found) {
        selectedDashboard = found;
      }
    } else if (this.props.plugin.dashboardId) {
      found = _.find(this.props.dashboards, b => b._id == this.props.plugin.dashboardId);
      if (found) {
        selectedDashboard = found;
      }
    } else if (this.props.plugin.boardId) {
      found = _.find(this.props.dashboards, b => b.boardId == this.props.plugin.boardId);
      if (found) {
        selectedDashboard = found;
      }
    } else if (!!this.props.params.dashboardId && !!OBJECT_ID_REGEX.test(this.props.params.dashboardId)) {
      found = _.find(this.props.dashboards, b => b._id == this.props.params.dashboardId);
      if (found) {
        selectedDashboard = found;
      }
    } else {
      found = _.find(
        this.props.dashboards,
        b => this.props.user.config && b._id == this.props.user.config.selectedDashboard
      );
      if (found) {
        selectedDashboard = found;
      }
    }

    if (!found) {
      this.props.router.push(`/dashboard/${selectedDashboard._id}/process`);
    } 
    else if (this.props.router.location.pathname === '/') {
      this.props.router.push(
        `/dashboard/${selectedDashboard._id}/process`
      );
    }else if (isDashboardWithoutId(this.props.router.location.pathname)) {
      this.props.router.push(
        `/dashboard/${selectedDashboard._id}/${this.props.router.location.pathname}`
      );
    }

    if (this.props.location.query.view) {
      this.props.applyView(selectedDashboard._id, this.props.location.query.view);
    }

    this.props.select(selectedDashboard, this.props.location.query.view);
  }

  handleChange(dashboard) {
    const match = this.props.router.location.pathname.match(/\/dashboard\/.+\/(.+)/i);
    if (match && match.length == 2) {
      this.props.clearData(match[1]);
      this.props.router.push(`/dashboard/${dashboard._id}/${match[1]}`);
    } else {
      const to = this.props && this.props.location && this.props.location.search !== '' ?
        `/dashboard/${dashboard._id}/${this.props.location.search}` :
        `/dashboard/${dashboard._id}/process`;
      this.props.router.push(to);
    }
    this.props.select(dashboard);
    this.props.saveSelected(dashboard._id);

    if (this.props.onChange) {
      this.props.onChange();
    }
  }

  handleUpdateClick(dashboard) {
    this.props.updateModel(dashboard);
    this.props.router.push('/update/' + dashboard._id);
  }

  handleExportClick = () => {
    this.props.exportCsv();
  };

  handleLogDownloadClick = dashboardId => {
    this.props.downloadReport(dashboardId);
  };

  handleShowFilter() {
    if (this.state.filter) {
      document.body.classList.add('filter-shown');
    } else {
      document.body.classList.remove('filter-shown');
    }
    this.setState({ filter: !this.state.filter });
  }

  handleAkbShowChecked(ev) {
    this.setState({ akbIsSet: false, akbFlag: !this.state.akbFlag, akbShowChecked: !this.state.akbFlag });
  }

  handleSearch = e => {
    this.setState({ q: e.target.value });
  };

  renderAkbButton(dashboard) {

    const akbConfig = this.getAkbConfig(dashboard);
    const { akbFlag } = this.state;
    const isAkb = dashboard.akbBoardId && dashboard.akbBoardId !== 'false';
    const showAkbButtonForDashboard = !isAkb; 

    const tooltip = (
      <Tooltip id="tooltip" className="tooltip_white">
        <span>Transform {this.props.selected ? (this.props.selected.label || this.props.selected.name) : ''} to an Advanced Kanban Board</span>
      </Tooltip>
    )

    const button = (
      <span className='img-dashboard'>
        <img src={akbGrayIcon} alt="" />
      </span>
    )
    
    if (akbConfig.showAkbButton && akbConfig.showInstallAkb && showAkbButtonForDashboard) {
      return (
        <Link to="/akb" className='btn btn-icon btn-secondary btn-sm btn-akb'>
          <OverlayTrigger placement="bottom" overlay={tooltip} delay={{ show: 250, hide: 2000 }}>
            {button}
          </OverlayTrigger>
        </Link>
      )
    }

    if (akbConfig.showAkbButton && !akbConfig.showInstallAkb && showAkbButtonForDashboard) {      
        return (
          <Confirm
            onConfirm={() => this.open(akbConfig.akbUrl)}
            body={
              <div>
                <p>
                  By clicking here, you'll be redirected to an external plugin offering advanced Kanban and Agile boards features.
                </p>
                <Checkbox
                  className='check_box_inline'
                  name="akbShow"
                  id="akbShow"
                  label="Don't ask me to create an Advanced Kanban Board anymore "
                  checked={akbFlag}
                  onChange={this.handleAkbShowChecked}
                />
              </div>
            }
            confirmClass="btn_orange_akb"
            confirmText="Proceed"
            icon={akbIcon}
            title="Explore Advanced Kanban & Agile Boards for Jira"
          >
            <Link className='btn_akb'>
              <OverlayTrigger placement="bottom" overlay={tooltip} delay={{ show: 250, hide: 2000 }}>
                {button}
              </OverlayTrigger>
            </Link>
          </Confirm>
        )      
    }
  }

  getAkbConfig(dashboard) {
    const { plugin, akbLoaded, akb } = this.props;

    const isJiraPlugin = dashboard && plugin && plugin.app === 'jira';
    const isPartnerHost = isJiraPlugin;
    const isAkbInstalled = akbLoaded && akb && akb.installed;
    const showInstallAkb = dashboard && isJiraPlugin && isPartnerHost && akbLoaded && !isAkbInstalled;
    const showAkbButton = this.state.akbShowChecked && dashboard && isJiraPlugin && isPartnerHost && akbLoaded;
    
    const withHost = plugin && plugin.host;
    const akbBaseUrl = withHost && `${plugin.host}${PLUGIN_PATH}/boards`;
    let akbUrl = `${akbBaseUrl}?ac.action=import&ac.bid=${dashboard.decodedBoardId}&ac.nid=${dashboard._id}`;

    return {      
      showInstallAkb,
      showAkbButton,
      akbUrl
    };
  }

  renderMenuItem(dashboard, isSelected) {
    const failedJob = !this.props.isLoading && _.first(dashboard.failedJobs);
    let failedJobMessage;
    if (!!failedJob && failedJob.type) {
      failedJobMessage = translate(`${failedJob.type}-short`);
    }

    const isAkb = dashboard.akbBoardId && dashboard.akbBoardId !== 'false';

    return (
      <React.Fragment>
        {isSelected && this.renderAkbButton(dashboard)}
        {dashboard.organization && !dashboard.organization.logo ? (
          isAkb ?
          (<span className='btn img-dashboard'>
            <img src={akbIcon} alt="default-board" />
          </span>) : 
          (<span className='btn img-dashboard'>
            <img src={defaultBoardImg} alt="default-board" />
          </span>)
        ) : !dashboard.organization ? (
          isAkb ? 
          (<span className='btn img-dashboard'>
            <img src={akbIcon} alt="default-board" />
          </span>) : 
          (<span className='btn img-dashboard'>
            <img src={personalBoardImg} alt="personal-board" />
          </span>)
        ) : (
          <span className='btn img-dashboard'>
            <img
              src={dashboard.organization.logo}
              alt="org-logo"
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = defaultBoardImg;
              }}
            />
          </span>
        )}
        <div className='dropdown-text'>
          <p>{dashboard.label || dashboard.name} </p>

          {!!failedJobMessage && <span className='sync-failed'>Update is required: {failedJobMessage}</span>}
          {!failedJobMessage && !!dashboard.createdBy && !dashboard.updatedBy && (
            <span>Created by: {dashboard.createdBy}</span>
          )}
          {!failedJobMessage && !!dashboard.updatedBy && (
            <span>Updated by: {dashboard.updatedBy}</span>
          )}
        </div>
      </React.Fragment>
    );
  }

  renderProgressDashboard(user) {
    if (user && user.allowedDashboards) {
      return <ProgressDashboard limitNumber={user.allowedDashboards} usedNumber={user.dashboards}/>
    }
  }

  render() {
    const { wallmode, outside, user, app, plugin, dashboards } = this.props;
    let buttons = [];
    const isJiraTopPlugin = plugin && plugin.app === 'jira' && plugin.noProject;
    const mainView = !outside || (outside && outside.app === 'jira' && outside.noBoard) || isJiraTopPlugin;
    
    const projectId = this.props.plugin.projectId;
    if (!wallmode) {
      if (mainView) {
        buttons = [
          hasCreateDashboards(this.props.user) && (
            <DropdownButton
              key="1"
              id="createdashboards-dropdown"
              variant='secondary'
              size='sm'
              title={
                <OverlayTrigger placement="bottom"
                  overlay={<Tooltip id="tooltip-createdashboards" className='tooltip_dark'>Create Dashboard</Tooltip>}>
                  <img src={createDashboardIcon} alt="" />
                </OverlayTrigger>
              }
            >
              <li>
                <Link key="1" to="/create" className='btn'>
                  <span className="title"><img src={createDashboardIcon} alt="#"/> Create dashboard</span>
                  <span className="help-text">
                    Select <FormattedMessage id={`${app}.board`} prefix={app} mode="capitalize" /> and drag &amp; drop
                    your <FormattedMessage id={`${app}.list`} plural="true" /> to define your workflow steps and build your team dashboard.
                  </span>
                  {this.renderProgressDashboard(user)}
                </Link>
              </li>             
            </DropdownButton>
          ),

          this.props.selected && (
            <DropdownButton
              key="2"
              id="dashboards-dropdown"
              size='sm'
              variant='secondary'
              title={
                <OverlayTrigger placement="bottom"
                  overlay={<Tooltip id="tooltip-settings" className='tooltip_dark'>Dashboard Settings</Tooltip>}>
                  <img src={settingsIcon} alt="" />
                </OverlayTrigger>
              }
            >
              <li onClick={ev => this.handleExportClick()}>
                <div className='btn'>
                  <span className="title"><img src={cloudDownload} alt="#"/> Export dashboard data</span>
                  <span className="help-text">Export your dashboard data as a CSV file to create custom reports</span>
                </div>
              </li>
              {hasDashboardAccess(this.props.user, this.props.selected._id, 'edit') && (
                <li onClick={ev => this.handleUpdateClick(this.props.selected)}>
                  <div className='btn'>
                    <span className="title"><img src={editIcon} alt="#"/> Edit dashboard</span>
                    <span className="help-text">
                      Map new process states, enable more custom fields and update your dashboard data.
                    </span>
                  </div>
                </li>
              )}
              {hasDashboardAccess(this.props.user, this.props.selected._id, 'delete') && (
                <li>
                  <Confirm
                    onConfirm={ev => this.props.remove(this.props.selected._id)}
                    body={
                      <p>
                        Are you sure you want to delete <strong>{this.props.selected.label || this.props.selected.name}</strong>?
                      </p>
                    }
                    confirmText="Delete"
                    icon={deleteIcon}
                    title="Delete dashboard" >
                    <div className='btn'>
                      <span className="title red"><img src={deleteIcon} alt="#"/> Delete dashboard</span>
                      <span className="help-text">
                        Delete dashboard and all the data synched with it. This action cannot be undone.
                      </span>
                      {this.renderProgressDashboard(user)}
                    </div>
                  </Confirm>
                </li>
              )}
              {user.remote &&
                this.props.selected.config &&
                this.props.selected.config.logCards &&
                hasDashboardAccess(this.props.user, this.props.selected._id, 'edit') && (
                  <li onClick={ev => this.handleLogDownloadClick(this.props.selected._id)}>
                    <div className='btn'>
                      Download log
                      <span className="help-text"></span>
                    </div>
                  </li>
                )}
            </DropdownButton>
          ),

          this.props.selected && (
            <DropdownButton
              key="3"
              id="dashboards-dropdown"
              size='sm'
              variant='secondary'
              title={
                <OverlayTrigger placement="bottom"
                  overlay={<Tooltip id="tooltip-wallboard" className='tooltip_dark'>Manage Wallboards</Tooltip>}>
                  <img src={wallboardIcon} alt="" />
                </OverlayTrigger>
              }
            >
              <li>
                <Link to={`/settings/${this.props.selected._id}`} className='btn'>
                  <span className="title"><img src={settingsIcon} alt="" /> Manage wallboards</span>
                  <span className="help-text">
                    Automatically rotate all the graphs in your dashboard on a big-screen for presentations, meetings or
                    team updates.
                  </span>
                </Link>
              </li>
            </DropdownButton>
          )
        ];
      } else {
        buttons = [
           projectId && hasCreateDashboards(this.props.user) && (
            <DropdownButton
              key="1"
              id="createdashboards-dropdown"
              variant='secondary'
              size='sm'
              title={
                <OverlayTrigger placement="bottom"
                  overlay={<Tooltip id="tooltip-createdashboards" className='tooltip_dark'>Create Dashboard</Tooltip>}>
                  <img src={createDashboardIcon} alt="" />
                </OverlayTrigger>
              }
            >
              <li>
                <Link key="1" to="/create" className='btn'>
                  <span className="title"><img src={createDashboardIcon} alt="#"/> Create dashboard</span>
                  <span className="help-text">
                    Select <FormattedMessage id={`${app}.board`} prefix={app} mode="capitalize" /> and drag &amp; drop
                    your <FormattedMessage id={`${app}.list`} plural="true" /> into the Kanban process flow.
                  </span>
                  {this.renderProgressDashboard(user)}
                </Link>
              </li>             
            </DropdownButton>
          ),         
          this.props.selected && (<DropdownButton
            key="2"
            id="dashboards-dropdown"
            size='sm'
            variant='secondary'
            title={
              <OverlayTrigger placement="bottom"
                overlay={<Tooltip id="tooltip-settings" className='tooltip_dark'>Dashboard Settings</Tooltip>}>
                <img src={settingsIcon} alt="" />
              </OverlayTrigger>
            }
          >
            <li>
              <Button onClick={ev => this.handleExportClick()}>
              <span className="title"><img src={cloudDownload} alt="#"/> Export dashboard data</span>
                <span className="help-text">Export your dashboard data as a CSV file to create custom reports</span>
              </Button>
            </li>
            {hasDashboardAccess(this.props.user, this.props.selected._id, 'edit') && (
              <li>
                <Button onClick={ev => this.handleUpdateClick(this.props.selected)}>
                  <span className="title"><img src={editIcon} alt="#"/> Edit dashboard</span>
                  <span className="help-text">
                    Map new process states or remove existing states from your Kanban process flow.
                  </span>
                </Button>
              </li>
            )}
            {hasDashboardAccess(this.props.user, this.props.selected._id, 'delete') && (
                <li>
                  <Confirm
                    onConfirm={ev => this.props.remove(this.props.selected._id)}
                    body={
                      <p>
                        Are you sure you want to delete <strong>{this.props.selected.label || this.props.selected.name}</strong>?
                      </p>
                    }
                    confirmText="Delete"
                    icon={deleteIcon}
                    title="Delete dashboard" >
                    <div className='btn'>
                      <span className="title red"><img src={deleteIcon} alt="#"/> Delete dashboard</span>
                      <span className="help-text">
                        Delete dashboard and all the data synched with it. This action cannot be undone.
                      </span>
                    </div>
                  </Confirm>
                </li>
              )}
            {user.remote &&
              this.props.selected.config &&
              this.props.selected.config.logCards &&
              hasDashboardAccess(this.props.user, this.props.selected._id, 'edit') && (
                <li>
                  <Button onClick={ev => this.handleLogDownloadClick(this.props.selected._id)}>
                    Download log
                    <span className="help-text"></span>
                  </Button>
                </li>
              )}
          </DropdownButton>),
          this.props.selected && (
            <DropdownButton
              key="3"
              id="dashboards-dropdown"
              size='sm'
              variant='secondary'
              title={
                <OverlayTrigger placement="bottom"
                  overlay={<Tooltip id="tooltip-wallboard" className='tooltip_dark'>Manage Wallboards</Tooltip>}>
                  <img src={wallboardIcon} alt="" />
                </OverlayTrigger>
              }
            >
              <li>
                <Link to={`/settings/${this.props.selected._id}`} className='btn'>
                  <span className="title"><img src={settingsIcon} alt="" /> Manage wallboards</span>
                  <span className="help-text">
                    Automatically rotate all the graphs in your dashboard on a big-screen for presentations, meetings or
                    team updates.
                  </span>
                </Link>
              </li>
            </DropdownButton>
          )
        ];
      }
    }

    if (this.props.windowWidth <= 992) {
      buttons.push(
        <Button key="4" id="filter-dropdown" 
                size='sm'
                variant='secondary'
                onClick={this.handleShowFilter}>
          <img src={filterIcon} alt="" />
        </Button>
      );
    } else if (this.props.selected && !wallmode) {
      buttons.push(
        <DropdownButton
          key="4"
          id="filter-dropdown"
          size='sm'
          variant='secondary'
          title={
            <OverlayTrigger placement="bottom"
                overlay={<Tooltip id="tooltip-dashboard" className='tooltip_dark'>Dashboard Views</Tooltip>}>
              <img src={dashboardIcon} alt="" />
            </OverlayTrigger>
          }>
          <li>
            <DashboardViews>
              <div className='btn'>
                <span className="title"><img src={applyIcon} alt="#" /> Apply dashboard view</span>
                <span className="help-text">
                  Apply the set of controls and filters previously stored on this dashboard
                </span>
              </div>
            </DashboardViews>
          </li>
          <li>
            <SaveDashboardView>
              <div className='btn'>
                <span className="title"><img src={saveIcon} alt="#" /> Save current dashboard view</span>
                <span className="help-text">Store the current set of controls and filters on this dashboard</span>
              </div>
            </SaveDashboardView>
          </li>
        </DropdownButton>
      );
    }

    const {
      hasAkbBoards,
      hasNormalBoards,      
      showDropDown
    } = getDashboardFlags(dashboards, outside, plugin, wallmode);

    const filteredNormalBoards = filterDashboards(
      dashboards,
      this.state.q,
      'normal'
    );

    const filteredAkbBoards = filterDashboards(
      dashboards,
      this.state.q,
      'advanced'
    );

    return (
      <Header showReport={true} 
        showSync
        dashboardSelector={
          <React.Fragment>
            {showDropDown ? (
              <DropdownButton
                className="dropdown-dashboard-list"
                title={this.props.selected ? this.renderMenuItem(this.props.selected, true) : ''}
                id="dashboards-dropdown"
                variant='secondary'
              >
                
                <Form.Group controlId="q" className='search-wrap'>
                  <Form.Control 
                    type="text" 
                    name="q"  
                    value={this.state.q} 
                    onChange={this.handleSearch} 
                    placeholder='Search Dashboard' />
                </Form.Group>
                <div className='dropdown-scroll'>
                  {hasNormalBoards && hasAkbBoards && <div className="subtitle">Jira boards</div>}
                  {hasNormalBoards && filteredNormalBoards
                      .map((dashboard, i) => {
                        return (
                          <Dropdown.Item
                            key={i}
                            className={this.props.selected && this.props.selected._id == dashboard._id ? 'active' : ''}
                            eventKey={i}
                            onClick={() => this.handleChange(dashboard)}
                          >
                            {this.renderMenuItem(dashboard, false)}
                          </Dropdown.Item>
                        );
                      })
                  }
                  {hasAkbBoards && <div className="subtitle">Advanced boards</div>}
                  {hasAkbBoards && filteredAkbBoards
                      .map((dashboard, i) => {
                        return (
                          <Dropdown.Item
                            key={i} 
                            className={this.props.selected && this.props.selected._id == dashboard._id ? 'active' : ''}
                            eventKey={i}
                            onClick={() => this.handleChange(dashboard)}
                            >
                            {this.renderMenuItem(dashboard)}
                          </Dropdown.Item>
                        );
                      }
                    )
                  }
                </div>
              </DropdownButton>
            ) : (
              <div className="title-dashboard">
                {!this.props.dataIsLoading && (
                  <div className='title-power-up'>
                    {this.props.selected ? this.renderMenuItem(this.props.selected) : ''}
                  </div>
                )}
              </div>
            )}
          </React.Fragment>
        }
        buttons={buttons}
      />
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    listAll: () => dispatch(listAll()),
    loadAkb: () => dispatch(loadAkb()),    
    updateModel: dashboard => dispatch(updateModel(dashboard)),
    select: (dashboardId, viewId) => dispatch(selectDashboard(dashboardId, viewId)),
    saveSelected: dashboardId => dispatch(saveSelected(dashboardId)),
    remove: id => dispatch(remove(id)),
    exportCsv: () => dispatch(exportCsv()),
    downloadReport: id => dispatch(downloadReport(id)),
    applyView: (dashboardId, viewId) => dispatch(applyView(dashboardId, viewId)),
    clearData: chart => {
      switch (chart) {
        case 'cfd':
          return dispatch(clearDataCFD());
      }
    }
  };
};

const mapStateToProps = state => {
  return {
    dataIsLoading: state.app.isLoading,
    app: state.app.app,
    wallmode: state.app.wallmode,
    outside: state.app.outside,
    plugin: state.app.plugin,
    user: state.auth.user,
    akb: state.dashboards.akb,
    akbLoaded: state.dashboards.akbLoaded,
    dashboards: state.dashboards.list,
    boards: state.dashboards.boards,
    isLoading: state.dashboards.isLoading,
    selected: state.dashboards.selected,
    noDashboards: state.dashboards.noDashboards
  };
};

export default windowSize(withRouter(connect(mapStateToProps, mapDispatchToProps)(DashboardSelector)));
